var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-dialog',{ref:"baseDialog",attrs:{"preventClosingDialog":false},on:{"positiveAction":_vm.handlePositiveAction,"neutralPositiveAction":_vm.handleNeutralPositiveAction}}),_c('confirmation-dialog',{ref:"confirm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }